import { render } from "./tableBody.vue?vue&type=template&id=65acf470&ts=true"
import script from "./tableBody.vue?vue&type=script&lang=ts"
export * from "./tableBody.vue?vue&type=script&lang=ts"

import exportComponent from "/home/asan/haisha/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__